module.exports = __webpack_public_path__ + "img/camera-video-off-fill.18e50f5f.svg";